import { ArchiveIcon } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { useBulkArchivePackages } from '@/api/packages/bulk-archive-packages'
import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { Typography } from '@/components/ui/typography'
import { toastFactory } from '@/factories'
import { PackageModel } from '@/models'
import { getApiErrorMessage } from '@/utils'

import * as S from './bulk-archive-modal.styled'

export interface BulkArchiveModalProps {
  onClose: () => void
  packages: PackageModel[]
}

export const BulkArchiveModal = ({ onClose, packages }: BulkArchiveModalProps) => {
  const { t } = useTranslation(['packages'])
  const { mutateAsync: bulkArchive, isPending } = useBulkArchivePackages()
  const count = packages.length

  const handleConfirm = async () => {
    try {
      await bulkArchive({ ids: packages.map((pkg) => pkg.id) })
      toastFactory.success(t('packages:bulkArchiveModal.toastSuccess', { count }))
      onClose()
    } catch (error) {
      toastFactory.error(getApiErrorMessage(error))
    }
  }

  return (
    <ConfirmationPopup
      autoWidth
      title={t('packages:bulkArchiveModal.title', { count })}
      confirmText={t('packages:bulkArchiveModal.confirm')}
      cancelText={t('packages:bulkArchiveModal.cancel')}
      variant="warning"
      closeable={!isPending}
      closeOnOverlayClick={!isPending}
      closeOnEscapeKey={!isPending}
      confirmIcon={ArchiveIcon}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <S.Container>
        <Typography color="black700" size="heading-medium" weight="medium">
          {t('packages:bulkArchiveModal.body')}
        </Typography>
      </S.Container>
    </ConfirmationPopup>
  )
}
